import { Either, Left, Right } from 'fp-ts/lib/Either'

import { log } from '@/log'
import { ApiService } from '@/services/api/service'
import { callWithAuth } from '@/services/auth/call-with-auth'
import { ApiClient } from './client'

const namespace: string = 'mail-magazine'

/**
 * メルマガ購読API (`PUT /api/user/mail-magazine`) のclient。
 *
 * 購読/解除をメルマガのpathnameで表現する。
 */
export class MailMagazineApiService extends ApiService {
  /**
   * メルマガ購読状態を一括更新する。
   *
   * @param subscribePathnames   購読するメルマガのpathname
   * @param unsubscribePathnames 解除するメルマガのpathname
   */
  async changeSubscription(
    subscribePathnames: string[],
    unsubscribePathnames: string[]
  ): Promise<Either<Error, void>> {
    // 購読・解除のどちらも対象がない場合は更新するものがないため、リクエストを送らず成功とする。
    if (subscribePathnames.length === 0 && unsubscribePathnames.length === 0) {
      return new Right(undefined)
    }

    try {
      const response = await callWithAuth(
        () => ApiClient.put(`/api/user/mail-magazine`).send({
          ...(subscribePathnames.length === 0 ? {} : {
            subscribe: subscribePathnames.join(','),
          }),
          ...(unsubscribePathnames.length === 0 ? {} : {
            unsubscribe: unsubscribePathnames.join(','),
          }),
        })
      )

      log.debug({ service: `${namespace}/change`, response })

      return new Right(undefined)
    } catch (error) {
      log.error({ service: `${namespace}/change`, error })

      return new Left(error)
    }
  }
}
